<template>
  <div class="tile is-parent">
    <article class="tile is-child box">
      <h3 class="title is-5">{{currentFashionMenu.moduleType | getModuleType}} <span v-if="currentFashionMenu.moduleType == 8" class="featured-good">精选好物</span><span v-if="currentFashionMenu.moduleType == 8" class="tip">(注：默认展示在发现页底部，不可调整模块顺序)</span></h3>
      <el-tabs v-model="activeName">
        <el-tab-pane label="模块设置" name="moduleSetting">
          <div class="margin-top-left-20">
            <p class="title">
              <el-checkbox v-model="moduleSetting.showTitle">是否展示标题</el-checkbox>
            </p>
            <div class="block width-2">
              <input class="input" type="text" v-model='moduleSetting.title'>
            </div>
            <template v-if="currentFashionMenu.moduleType !== 8">
              <p class="title">显示 "查看全部" <i>(客户端不需要展示则留空)</i></p>
              <div class="block width-2">
                <input class="input" type="text" v-model='moduleSetting.moreTitle'>
              </div>
              <p class="title">"查看全部" 跳转链接</p>
              <div class="block cyzs-w-400">
                <custom-link :link='moduleSetting.moreLink' @update:link="val => { moduleSetting.moreLink = val }"></custom-link>
              </div>
            </template>
            <p class="block title">显示状态</p>
              <p class="block">
                <el-radio class="radio" v-model='moduleSetting.status' :label="1">开启</el-radio>
                <el-radio class="radio" v-model='moduleSetting.status' :label="0">关闭</el-radio>
              </p>
            <template v-if="currentFashionMenu.moduleType !== 8">
              <div class="slider-wrap">
                <p class="title">
                  <span>与上一模块间距（px)</span>
                  <el-tooltip class="item" effect="dark" content="填写的数值请以 750px宽度的设计稿像素为标准" placement="top">
                    <span class='cursor-point'><i class='fa fa-question-circle'></i></span>
                  </el-tooltip>
                </p>
                <p>
                  <el-slider v-model="moduleSetting.marginTop" :max="400" :show-input="true"></el-slider>
                </p>
              </div>
            </template>
            <!--猜搭配模块有以下间距配置 start-->
            <div v-if="currentFashionMenu.moduleType == 4">
              <div class="slider-wrap">
                <p class="title">
                  <span>水平间距（px）</span>
                  <el-tooltip class="item" effect="dark" content="填写的数值请以 750px宽度的设计稿像素为标准" placement="top">
                    <span class='cursor-point'><i class='fa fa-question-circle'></i></span>
                  </el-tooltip>
                </p>
                <p>
                  <el-slider v-model="moduleSetting.marginLeft" :max="400" :show-input="true"></el-slider>
                </p>
              </div>
              <div class="slider-wrap">
                <p class="title">
                  <span>图片高度（px）</span>
                  <el-tooltip class="item" effect="dark" content="填写的数值请以 750px宽度的设计稿像素为标准" placement="top">
                    <span class='cursor-point'><i class='fa fa-question-circle'></i></span>
                  </el-tooltip>
                </p>
                <p>
                  <el-slider v-model="moduleSetting.moduleHeight" :max="400" :show-input="true"></el-slider>
                </p>
              </div>
            </div>
            <div v-if="routerName == 'discovery'" class="slider-wrap">
              <div class="title">是否展示底部分割线</div>
              <div class="block">
                <label><input type="radio" :value="1" v-model="moduleSetting.isShowTopLine" name="isShowTopLine">是</label>
                <label><input type="radio" :value="0" v-model="moduleSetting.isShowTopLine" name="isShowTopLine">否</label>
              </div>
            </div>
            <!--猜搭配模块有以上间距配置 end-->
          </div>
          <div class="margin-top-left-20">
            <button class="button is-success" @click='doSaveModule()'>保存</button>
            <button class="button is-info" v-if='moduleSetting.status==2' @click='archiveModule(moduleSetting.status)'>还原模块</button>
            <button class="button is-info" v-if='currentFashionMenu.moduleId && moduleSetting.status!=2 && currentFashionMenu.moduleType != 8' @click='archiveModule(moduleSetting.status)'>归档模块</button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </article>
  </div>
</template>

<script type="text/babel">
  import CustomLink from 'COMMON/DefinedLink';
  import { mapState, mapActions } from 'vuex';

  export default {
    data() {
      return {
        activeName: 'moduleSetting',
        moduleSetting: {
          title: '',
          showTitle: false,
          status: 1,
          moreTitle: '',
          moreLink: '',
          marginTop: 20,
          marginLeft:20,
          moduleHeight:20,
		  isShowTopLine: 1,
        },
		routerName: ''
	  }
    },
    watch: {
      currentFashionMenu: {
        handler(val) {
          if (this.currentFashionMenu.moduleId) {
            this.getModule()
          } else {
            this.moduleSetting = {
              title: '',
              showTitle: false,
              status: 1,
              moreTitle: '',
              moreLink: '',
              marginTop: 0,
              marginLeft:0,
              moduleHeight:0,
			  isShowTopLine: 1
            }
          }
        },
        deep: true
      }
    },
    computed: {
      ...mapState({
        currentFashionMenu: state => state.currentFashionMenu
      }),
      marginTopPer () {
        return this.moduleSetting.marginTop + 'px'
      },
      marginLeftPer () {
        return this.moduleSetting.marginLeft + 'px'
      },
      moduleHeightPer(){
        return this.moduleSetting.moduleHeight + 'px'
      },
    },
    mounted() {
      if (this.currentFashionMenu.moduleType == -1) {
        this.setCurrentFashionMenuByVuex({
          type: this.$route.query.type,
          moduleType:this.$route.query.moduleType,
          moduleId:this.$route.query.moduleId
        })
      }
      if (this.currentFashionMenu.moduleId) {
        this.getModule()
        this.routerName = this.$route.name
      }
    },
    methods: {
      getModule() {
        HttpRequest.get("/admin.php?method=fashion.getModule", {moduleId: this.currentFashionMenu.moduleId}).then((response) => {
          this.moduleSetting.title = response.data.title
          this.moduleSetting.showTitle = response.data.showTitle == 1
          this.moduleSetting.status = response.data.status
          this.moduleSetting.moreTitle = response.data.moreTitle
          this.moduleSetting.moreLink = response.data.moreLink
          this.moduleSetting.marginTop = response.data.marginTop ? response.data.marginTop * 2 : 0
          this.moduleSetting.marginLeft = response.data.marginLeft ? response.data.marginLeft * 2 : 0
          this.moduleSetting.moduleHeight = response.data.moduleHeight ? response.data.moduleHeight * 2 : 0
          this.moduleSetting.isShowTopLine = response.data.isShowTopLine ? 1 : 0
        })
      },
      doSaveModule() {
        if(this.moduleSetting.moreTitle){
          if(!this.moduleSetting.moreLink){
            return
          }
        }else{
          this.moduleSetting.moreLink = "";
        }

        let params = Object.assign({}, this.currentFashionMenu, this.moduleSetting, {showTitle: this.moduleSetting.showTitle ? 1 : 0, isShowTopLine: this.moduleSetting.isShowTopLine ? 1 : 0, marginTop: this.moduleSetting.marginTop / 2, marginLeft: this.moduleSetting.marginLeft / 2, moduleHeight: this.moduleSetting.moduleHeight / 2})
        //非猜搭配删除一下字段
        if(this.currentFashionMenu.moduleType != 4){
          delete params.marginLeft;
          delete params.moduleHeight;
        }
        HttpRequest.post("/admin.php?method=fashion.doSaveModule", params).then((response) => {
          if (response.data.success) {
            setTimeout(() => {
              this.commitFashionMenuUpdate(true)
            }, 2000)
            this.$message('保存成功')
          }
        })
      },
      archiveModule(status) {
        let params = {
          moduleId: this.currentFashionMenu.moduleId,
          actionType: 0
        }
        if (status == 2) {
          params.actionType = 1
        } else  {
          params.actionType = 0
        }
        HttpRequest.get("/admin.php?method=fashion.archiveModule", params).then((response) => {
          if (response.data.success) {
            setTimeout(()=>{
              this.commitFashionMenuUpdate(true)
            },2000)
            this.$message('操作成功')
          }
        })
      },
      ...mapActions([
        'commitFashionMenuUpdate', 'setCurrentFashionMenuByVuex'
      ]),
    },
    filters:{
//      * 0:热区1:横滑2:轮播3:系统-全民搭配师4:系统-猜搭配5:系统-视频学穿搭6:系统-干货笔记
      getModuleType(moduleType){
        switch(moduleType){
          case 3:
            return "全民搭配师";
            break;
          case 4:
            return "猜搭配";
            break;
          case 5:
            return "视频学穿搭";
            break;
          case 6:
            return "干货笔记";
            break;
          case 7:
            return "店铺关注";
            break;
		  case 9:
			return "穿搭手册";
			break;
        }
      }
    },
    components: { CustomLink }
  }
</script>
<style lang="less" scoped>
  .title.is-5{
    .tip{
      font-weight: normal;
      color: red;
      font-size: 16px;
    }
  }
  .featured-good{
    font-weight: bold;

  }
  .margin-top-left-20{
    margin: 20px 0 0 20px;
  }
</style>
